module.exports = __webpack_public_path__ + "img/centrum-cadeaubon-mockup.d8e40db5.jpg";